export const filterOptions = {
  // 0: 'Chưa gặp',
  // 1: 'Gặp 1 lần',
  // 2: 'Gặp 2 lần',
  // 3: 'Gặp 3 lần',
  // 4: 'Gặp > 3 lần',
  5: 'Chốt lịch học BVLN',
  6: 'Danh sách yêu thích',
};
